/**
 * Created by Ning Jiang on 2/24/2020.
 */

import {IReelStoppedData} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {ReelStopPresentationController} from "@nolimitcity/slot-game/bin/core/reelstoppresentation/ReelStopPresentationController";
import {DeadwoodSoundConfig} from "../../DeadwoodSoundConfig";
import {DeadwoodParsedGameData} from "../../server/data/DeadwoodParsedGameData";
import {DeadwoodReelSymbol} from "../../symbols/DeadwoodReelSymbol";

export class DeadwoodBonusLowSymAttentionController extends ReelStopPresentationController {

    private _bonusPositions:number[];
    private _bonusTriggered:boolean;
    private _fsSuperModeActive:boolean;

    constructor(index:number) {
        super(index, "BonusLowSym");
    }

    protected parseFeatureGameData(data:DeadwoodParsedGameData):void {
        this._bonusPositions = data.bonusPositions;
        this._bonusTriggered = data.bonusTriggeredThisSpin;
        this._fsSuperModeActive = data.fsSuperModeActive;
    }

    public onReelBounce(data:IReelStoppedData):void {
        if(data.reelId === 0 || data.reelId === 4) {
            return this.dispatchCompleteEvent(data.reelId);
        }

        // make sure the server sends the positions even in super fs mode.
        if(this._bonusPositions[0] > 0) {
            let hasSymbol:boolean = false;
            for(let i:number = 0; i < 4; i++) {
                const symbol:DeadwoodReelSymbol = <DeadwoodReelSymbol>Reels.getSymbol(data.reelId, i);
                if(!symbol) {
                    continue;
                }
                if(symbol.symName.includes("L")) {
                    symbol.playBonusAttention(this._fsSuperModeActive && !this._bonusTriggered);
                    hasSymbol = true;
                }
            }
            if(hasSymbol) {
                DeadwoodSoundConfig.playBustedWildLandingSound(data.reelId);
            }
        }

        this.dispatchCompleteEvent(data.reelId);
    }
}